import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';

interface ItemType {
    img: string;
    name: string;
    link: string;
    productId: string;
    variantId: string;
    subs: string[];
}

const P: React.FC = () => {
    const { t } = useLang('d3u');
    const { locale = '' } = useRouter();
    const data: ItemType[] = [
        {
            img: '',
            name: t('P_item1_name'),
            link: 'https://jp.ecoflow.com/products/delta-3-ultra-portable-station?variant=52291943104879',
            productId: '14803254870383',
            variantId: '52291943104879',
            subs: [
                t('P_item1_sub1_name'),
                t('P_item1_sub2_name'),
                t('P_item1_sub3_name'),
                t('P_item1_sub4_name'),
                t('P_item1_sub5_name'),
                t('P_item1_sub6_name'),
                t('P_item1_sub7_name'),
                t('P_item1_sub8_name'),
                t('P_item1_sub9_name'),
                t('P_item1_sub10_name'),
                t('P_item1_sub11_name'),
            ],
        },
        {
            img: '',
            name: t('P_item2_name'),
            link: 'https://jp.ecoflow.com/products/delta-3-ultra-plus-portable-station?variant=52291938976111',
            productId: '14803254935919',
            variantId: '52291938976111',
            subs: [
                t('P_item2_sub1_name'),
                t('P_item2_sub2_name'),
                t('P_item2_sub3_name'),
                t('P_item2_sub4_name'),
                t('P_item2_sub5_name'),
                t('P_item2_sub6_name'),
                t('P_item2_sub7_name'),
                t('P_item2_sub8_name'),
                t('P_item2_sub9_name'),
                t('P_item2_sub10_name'),
                t('P_item2_sub11_name'),
            ],
        },
    ];
    const [items, setItems] = useState<ItemType[]>(data as ItemType[]);

    const getAsynItem = async (item: ItemType) => {
        const { productId, variantId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.img = res?.data?.variantImg || res?.data?.img || '/';
                    return resolve(item);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const init = async () => {
            const tempArr: ItemType[] = [...data];
            const promises: Promise<ItemType>[] = tempArr?.map((item: any) => getAsynItem(item) as Promise<ItemType>);
            const res: ItemType[] = await Promise.all(promises);
            setItems(res);
        };
        init();
    }, []);

    return (
        <section className={`${css.section} D3U-P GtmModuleData-section`} id="D3U-P" data-section-id={'D3U-P'} data-section-id2={t('P_title')}>
            <div className="info">
                <p className="title">{t('P_title')}</p>
            </div>
            <ul className="items">
                {items?.map((item: ItemType, k: number) => (
                    <li className="item" key={item.variantId}>
                        <div className="img">
                            <EcoImg pc={item.img} />
                        </div>
                        <p className="tag">{t('P_tag')}</p>
                        <p className="name">{item.name}</p>
                        <EcoLink
                            className={`link link-${k + 1} GtmModule-btn-href`}
                            href={item.link}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: item.name,
                                position: `Product Detail_${item.name}`,
                                __btn_id1: `${css.section} .link-${k + 1}`,
                                __btn_id2: item.link,
                                __btn_type: 'href',
                            }}
                        >
                            {t('P_link')}
                        </EcoLink>
                        <div className="line"></div>
                        <ul className="subs">
                            {item.subs?.map((sub: string, m: number) => (
                                <li className="sub" key={`${item.variantId}_${k}_${m}`}>
                                    <p className="sub-name">{sub}</p>
                                    <p className="sub-text">{t(`P_sub${m + 1}_text`)}</p>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default P;
